/**
 * ClubConfirmation.js — Club signup confirmation (kind "club-confirmation").
 *
 * Common Commerce7 club feature. Parity with old showOrderConfirmation's
 * "Membership Joined!" wording (order?.clubMembershipId != null).
 *
 * message.data: { orderId, clubTitle, isMembership }
 */

export default class ClubConfirmation {
  render(message) {
    const orderId = message?.data?.orderId || "";
    const clubTitle = message?.data?.clubTitle || "";
    const isMembership = !!message?.data?.isMembership;

    const row = document.createElement("div");
    row.className = "ws-bot-row";

    const avatar = document.createElement("div");
    avatar.className = "ws-avatar ws-bot-avatar";
    row.appendChild(avatar);

    const wrap = document.createElement("div");
    wrap.className = "ws-bubble-wrap";

    const bubble = document.createElement("div");
    bubble.className = "ws-bot-bubble";
    bubble.style.display = "flex";
    bubble.style.flexDirection = "column";
    bubble.style.gap = "6px";

    const title = document.createElement("div");
    title.style.fontWeight = "600";
    title.textContent = isMembership ? "✅ Membership Joined!" : "✅ Order Placed!";
    bubble.appendChild(title);

    const body = document.createElement("div");
    body.textContent = clubTitle
      ? `Welcome to the ${clubTitle}!`
      : "You're all set.";
    if (orderId) {
      body.appendChild(document.createTextNode(" Your confirmation number is "));
      const id = document.createElement("strong");
      id.textContent = orderId;
      body.appendChild(id);
      body.appendChild(document.createTextNode("."));
    }
    bubble.appendChild(body);

    wrap.appendChild(bubble);
    row.appendChild(wrap);
    return row;
  }
}
